export default __webpack_public_path__ + "static/2-715d32de1cd1be364000dd9841928f2e.jpeg";